var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faUser, faQuestion, faXmark, } from '@awesome.me/kit-cf858715fd/icons/classic/solid';
import { theme } from '@robinpowered/ui-kit';
import { getInviteeRole, } from '../../utils/inviteeRoles';
export var useAttendeesCard = function (_a) {
    var invitees = _a.invitees, inviteeCount = _a.inviteeCount, event = _a.event;
    var token = theme.useToken().token;
    var colorSuccess = token.colorSuccess, colorError = token.colorError, colorWarning = token.colorWarning;
    var _b = useMemo(function () {
        /* inviteeUserCount is the number of users in the invitees list */
        /* inviteeCount is the number of users in the reservation approval list*/
        if (!invitees && !inviteeCount)
            return { inviteeUserCount: 0, totalCount: 0, inviteeInfo: [] };
        var inviteeUserCount = invitees.length;
        var totalCount = inviteeUserCount + inviteeCount;
        /* Compute each invitee's role once — used for both sorting and the
           role label rendered by AttendeesCard */
        var withRoles = invitees.map(function (invitee) { return (__assign(__assign({}, invitee), { role: getInviteeRole(event !== null && event !== void 0 ? event : {}, invitee, invitee.is_organizer) })); });
        /* Order: organizer first, then creator, then everyone else */
        var rank = function (role) {
            return role === 'organizer' ? 0 : role === 'creator' ? 1 : 2;
        };
        var sorted = withRoles.sort(function (a, b) { return rank(a.role) - rank(b.role); });
        return {
            inviteeUserCount: inviteeUserCount,
            totalCount: totalCount,
            inviteeInfo: sorted,
        };
    }, [invitees, inviteeCount, event]), inviteeUserCount = _b.inviteeUserCount, totalCount = _b.totalCount, inviteeInfo = _b.inviteeInfo;
    var estimatedAttendeesCount = totalCount - inviteeUserCount;
    // Helper function to get invitee display data
    var getInviteeData = function (invitee) {
        var _a, _b;
        return {
            name: ((_a = invitee.user) === null || _a === void 0 ? void 0 : _a.name) || invitee.display_name,
            avatar: (_b = invitee.user) === null || _b === void 0 ? void 0 : _b.avatar,
            icon: _jsx(FontAwesomeIcon, { icon: faUser, size: "sm" }),
        };
    };
    // Helper function to get status icon and visibility
    var getStatusIcon = function (responseStatus) {
        switch (responseStatus) {
            case 'accepted':
                return {
                    icon: faCheck,
                    show: true,
                    color: colorSuccess,
                };
            case 'declined':
                return {
                    icon: faXmark,
                    show: true,
                    color: colorError,
                };
            case 'tentative':
                return {
                    icon: faQuestion,
                    show: true,
                    color: colorWarning,
                };
            case 'unknown':
            case 'not_responded':
            case 'delegated':
            default:
                return { icon: null, show: false };
        }
    };
    return {
        inviteeInfo: inviteeInfo,
        totalCount: totalCount,
        inviteeUserCount: inviteeUserCount,
        estimatedAttendeesCount: estimatedAttendeesCount,
        getInviteeData: getInviteeData,
        getStatusIcon: getStatusIcon,
    };
};
